module.exports = __webpack_public_path__ + "media/img/pages/companies/meggitt-992f72e364b00a605ae8a4b8a5d44d0a.jpg";